<template>
  <div class="lxm-dashboard-user-guide_item">
    <a :href="href" target="_blank">
      <img class="lxm-dashboard-user-guide_item-img" :src="image" :alt="name">
    </a>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../../styles/index.styl'
  .lxm-dashboard-user-guide_item
    &:first-child
      margin-right: siz(25)
    &:last-child
      margin-left: siz(25)
  .lxm-dashboard-user-guide_item-img
    width: siz(90)
</style>

<script>
  export default {
    props: {
      name: String,
      href: String,
      image: String
    }
  }
</script>



// WEBPACK FOOTER //
// GuideItem.vue?daf7ebb0